/* Focus the visible return control after the native drawer reveals its next level. */
document.querySelectorAll('#shopify-section-header .menu-drawer__navigation').forEach((navigation) => {
  let pending;
  let frame;
  const queueFocus = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if (!pending?.open || !pending.classList.contains('menu-opening')) return;
      // A previous native return animation may still restore focus to its summary.
      const closing = Array.from(navigation.querySelectorAll('details[open]')).some((other) =>
        other !== pending && !other.classList.contains('menu-opening') && !other.contains(pending) && !pending.contains(other)
      );
      if (closing) return;
      pending.querySelector(':scope > .menu-drawer__submenu .menu-drawer__close-button')?.focus({ preventScroll: true });
      pending = null;
    });
  };
  new MutationObserver(() => { if (pending) queueFocus(); }).observe(navigation, { subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
  navigation.querySelectorAll('details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        pending = details;
        queueFocus();
      } else if (pending === details) pending = null;
    });
  });
});
